import React from 'react';
import { FaInbox } from 'react-icons/fa';
import './EmptyState.css';

/**
 * EmptyState Component
 * Displayed when there's no data
 */
const EmptyState = ({
  // icon = <FaInbox />,
  title = 'No data found',
  description = '',
  action = null,
  className = ''
}) => {
  return (
    <div className={`empty-state ${className}`}>
      {/* <div className="empty-state-icon">{icon}</div> */}
      <h3 className="empty-state-title">{title}</h3>
      {description && <p className="empty-state-description">{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;